import Tooltip from './components/tooltip/Tooltip'
import { isEmpty } from 'lodash'
import Vue from 'vue'

export function appendHelpyComponent(helpy) {
  let targetElement
  if (helpy && !isEmpty(helpy)) {
    Object.keys(helpy).forEach((selector) => {
      if (!selector) return
      targetElement = document.querySelector(selector)
      if (!targetElement) return
      targetElement.parentNode.appendChild(helpy[selector])
      targetElement.parentNode.style.position = 'relative'
    })
  }
}

export function loadHelpy(helpy) {
  const elements = {}
  if (helpy && !isEmpty(helpy)) {
    let instance
    const ComponentClass = Vue.extend(Tooltip)
    Object.keys(helpy).forEach((selector) => {
      instance = new ComponentClass({
        propsData: { helpies: helpy[selector] },
      })
      instance.$mount()
      elements[selector] = instance.$el
    })
  }
  return elements
}
